import React from "react";
import ImagemOmegaImpressao from "../../../assets/img/logo.png";
import {
    guardarDadosUsuario,
    guardarDadosUsuario2,
    obterDadosUsuario2,
} from "../../../services/cookies";
import { obterHistoricoFechamento } from "../../../services/fechamento";
import { obterIdFundoAcessoria } from "../../../services/fundoFinanceiro";
import { obterFundoFinanceiro, renovacaoToken } from "../../../services/usuario";
import { Fechamentos } from "./HistoricoFechamento";

const erroNaoAutorizado = (err: any) =>
    err?.response?.status === 401 || String(err).includes("status code 401");

const guardarTokensRenovados = (res: any) => {
    const dadosUsuario = obterDadosUsuario2();
    const tokenAcesso = res.data.camposAdicionais.tokenAcesso;
    const tokenRenovacao = res.data.camposAdicionais.tokenRenovacao;
    const email = dadosUsuario.email?.toString() || "";
    const id = dadosUsuario.id?.toString() || "";

    guardarDadosUsuario(tokenAcesso, tokenRenovacao, email, id, dadosUsuario.urlAvatar || undefined);
    guardarDadosUsuario2(tokenAcesso, tokenRenovacao, email, id, dadosUsuario.urlAvatar || undefined);

    return tokenAcesso;
};

const renovarTokenAtual = async () => {
    const { token, tokenRenovacao } = obterDadosUsuario2();
    const res = await renovacaoToken(token, tokenRenovacao);

    return guardarTokensRenovados(res);
};

export const criaPDFHistoricoFechamento = () => {
    const tabela = document.getElementById("tblTransacoes");

    if (!tabela) {
        return;
    }

    const minhaTabela = tabela.innerHTML;

    var style = "<style>";
    style = style + "table {width: 100%;font: 12px Calibri;}";
    style =
        style +
        "table, th, td { border: solid 1px #DDD; border-collapse: collapse;";
    style = style + "padding: 2px 3px;text-align: center;}";
    style = style + "img {width: 20%; height: 20%}";
    style =
        style +
        "div {display: flex; justify-content: center; margin-bottom: 15px;}";
    style = style + "</style>";

    var win = window.open("", "", "height=700,width=700");

    if (!win) {
        return;
    }

    win.document.write("<html><head>");
    win.document.write("<title></title>");
    win.document.write(style);
    win.document.write("</head>");
    win.document.write("<body>");
    win.document.write(
        `<div><img src="${ImagemOmegaImpressao}"></img></div>`
    );
    win.document.write("<table>");
    win.document.write(minhaTabela);
    var removerColuna = win.document.getElementById("colunaFechamento");
    removerColuna?.parentNode?.removeChild(removerColuna);
    const removerDadosColuna = win.document.querySelectorAll(".verComprovante");
    removerDadosColuna.forEach((verComprovante) => {
        verComprovante.remove();
    });

    win.document.write("</table>");
    win.document.write("</body></html>");
    win.document.close();
    setTimeout(function () {
        win.print();
    }, 500);
};

export async function handleHistoricoFechamento(
    dataInicial: Date,
    dataFinal: Date,
    setFechamentos: React.Dispatch<React.SetStateAction<Fechamentos[]>>,
    setError: React.Dispatch<boolean>,
    setLoading: React.Dispatch<boolean>,
    setDesconectar: React.Dispatch<boolean>,
    idFundoFinanceiro: string,
    token: string
) {
    setLoading(true);
    setError(false);

    const dataInicialZerada = new Date(new Date(dataInicial).setHours(0, 1, 0)).toISOString();
    const dataFinalPesquisa = new Date(new Date(dataFinal).setHours(23, 59, 0)).toISOString();

    try {
        const res = await obterHistoricoFechamento(
            dataInicialZerada,
            dataFinalPesquisa,
            true,
            token,
            idFundoFinanceiro
        );

        setFechamentos(res.data.resultado.fechamentos);
    } catch (err) {
        if (!erroNaoAutorizado(err)) {
            setError(true);
            return;
        }

        try {
            const tokenAcesso = await renovarTokenAtual();
            const res = await obterHistoricoFechamento(
                dataInicialZerada,
                dataFinalPesquisa,
                true,
                tokenAcesso,
                idFundoFinanceiro
            );

            setFechamentos(res.data.resultado.fechamentos);
        } catch (retryErr) {
            if (erroNaoAutorizado(retryErr)) {
                setDesconectar(true);
                return;
            }

            setError(true);
        }
    } finally {
        setLoading(false);
    }
}

export const obterIdFundoFinanceiroAcessoria = async (
    setErro: React.Dispatch<boolean>,
    setDesconectar: React.Dispatch<boolean>,
    dataInicial: Date,
    dataFinal: Date,
    setFechamentos: React.Dispatch<React.SetStateAction<Fechamentos[]>>,
    setLoading: React.Dispatch<boolean>,
) => {
    const { token } = obterDadosUsuario2();

    try {
        const res = await obterIdFundoAcessoria(token);
        await handleHistoricoFechamento(
            dataInicial,
            dataFinal,
            setFechamentos,
            setErro,
            setLoading,
            setDesconectar,
            res.data.resultado.fundoFinanceiro.id,
            token
        );
    } catch (err) {
        if (!erroNaoAutorizado(err)) {
            setErro(true);
            return;
        }

        try {
            const tokenAcesso = await renovarTokenAtual();
            const res = await obterIdFundoAcessoria(tokenAcesso);
            await handleHistoricoFechamento(
                dataInicial,
                dataFinal,
                setFechamentos,
                setErro,
                setLoading,
                setDesconectar,
                res.data.resultado.fundoFinanceiro.id,
                tokenAcesso
            );
        } catch (retryErr) {
            if (erroNaoAutorizado(retryErr)) {
                setDesconectar(true);
                return;
            }

            setErro(true);
        }
    }
};

export const obterFundoFinaceiroPrivate = async (
    idCredenciais: string,
    setErro: React.Dispatch<boolean>,
    setDesconectar: React.Dispatch<boolean>,
    dataInicial: Date,
    dataFinal: Date,
    setFechamentos: React.Dispatch<React.SetStateAction<Fechamentos[]>>,
    setLoading: React.Dispatch<boolean>,
) => {
    const { token } = obterDadosUsuario2();

    try {
        const res = await obterFundoFinanceiro(token, idCredenciais);
        const fundoPrivate = res.data.resultado.clientes.filter(
            (fundo: { id: string, servicoFinanceiro: string }) =>
                fundo.servicoFinanceiro === "Private"
        )[0];

        await handleHistoricoFechamento(
            dataInicial,
            dataFinal,
            setFechamentos,
            setErro,
            setLoading,
            setDesconectar,
            fundoPrivate.id,
            token
        );
    } catch (err) {
        if (!erroNaoAutorizado(err)) {
            setErro(true);
            return;
        }

        try {
            const tokenAcesso = await renovarTokenAtual();
            const res = await obterFundoFinanceiro(tokenAcesso, idCredenciais);
            const fundoPrivate = res.data.resultado.clientes.filter(
                (fundo: { id: string, servicoFinanceiro: string }) =>
                    fundo.servicoFinanceiro === "Private"
            )[0];

            await handleHistoricoFechamento(
                dataInicial,
                dataFinal,
                setFechamentos,
                setErro,
                setLoading,
                setDesconectar,
                fundoPrivate.id,
                tokenAcesso
            );
        } catch (retryErr) {
            if (erroNaoAutorizado(retryErr)) {
                setDesconectar(true);
                return;
            }

            setErro(true);
        }
    }
};
